import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Clock } from "lucide-react";

export default function TrialBanner() {
  const [s, setS] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/billing/status");
        if (data?.applicable) setS(data);
      } catch (err) {
        if (process.env.NODE_ENV === "development") console.warn("[TrialBanner] /billing/status failed", err);
      }
    })();
  }, []);
  if (!s || s.state === "active" && s.days_left > 14) return null;
  const tone =
    s.state === "expired" ? "bg-red-50 border-red-200 text-red-800"
    : s.state === "trial" && s.days_left <= 7 ? "bg-amber-50 border-amber-200 text-amber-900"
    : "bg-[#0A8B85]/5 border-[#0A8B85]/20 text-[#0A8B85]";
  return (
    <div data-testid="trial-banner" className={"mb-4 flex items-center justify-between gap-4 rounded-xl border px-4 py-2.5 text-sm " + tone}>
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4"/>
        {s.state === "trial" && <span><b>{s.days_left} days left</b> on your free trial — no card required until then.</span>}
        {s.state === "active" && <span><b>{s.days_left} days</b> remaining on your <b>{s.plan}</b> plan.</span>}
        {s.state === "expired" && <span>Your trial has ended. <b>Upgrade to keep your deal flow.</b></span>}
      </div>
      <Link to="/funder/billing" data-testid="trial-banner-cta"
        className={"rounded-md px-3 py-1.5 text-xs font-semibold " +
          (s.state === "expired" ? "bg-red-600 text-white hover:bg-red-700" : "bg-[#0A8B85] text-white hover:bg-[#066667]")}>
        {s.state === "expired" ? "Choose a plan" : "View plans"}
      </Link>
    </div>
  );
}
